module.exports = __webpack_public_path__ + "img/prepaid-credit-card-providers.08248b2.webp";